/* "Pick your free gifts" popup (sections/lumi-email-popup.liquid).
   pick (who are you buying for) → email → done. Emails are posted to Shopify's storefront customer form, so they
   land in Customers subscribed to email marketing and tagged with who they're buying for. PostHog gets the same
   email_submitted event the dashboard already reads, which doubles as a backup if Shopify's form is challenged. */
(function () {
  var root = document.querySelector('[data-lgp]');
  if (!root) return;

  var DONE = 'lumi_gift_popup_done';        // signed up here: never show again
  var SNOOZE = 'lumi_gift_popup_snooze';    // closed without signing up (only if suppressDays > 0)
  var SHOWN = 'lumi_gift_popup_shown';      // once per browsing session (per popup: the long-distance one has its own)
  var OLD_DONE = ['tec_submitted', 'terra_quiz_done']; // gave their email to the old quiz popup

  var cfg = {};
  try { cfg = JSON.parse(root.querySelector('[data-lgp-settings]').textContent); } catch (e) {}
  // The long-distance popup (sections/lumi-ldr-popup.liquid) reuses this script with its own gifts, question and tags.
  if (cfg.key) SHOWN += '_' + cfg.key;
  var PLACEMENT = cfg.placement || 'gift_popup';

  // ?popup=reset (any page): forget this browser's popup history and open it straight away. For testing/QA links.
  var forceOpen = /(?:^|[?&])popup=reset(?:&|$)/.test(location.search);
  if (forceOpen) {
    try {
      [DONE, SNOOZE].concat(OLD_DONE).forEach(function (k) { localStorage.removeItem(k); });
      sessionStorage.removeItem(SHOWN);
    } catch (e) {}
  }

  try {
    if (localStorage.getItem(DONE) || OLD_DONE.some(function (k) { return localStorage.getItem(k); })) return;
    var until = parseInt(localStorage.getItem(SNOOZE) || '0', 10);
    if (until && Date.now() < until) return;
    if (sessionStorage.getItem(SHOWN)) return;
  } catch (e) { /* storage blocked: still show */ }

  var dialog = root.querySelector('[data-lgp-dialog]');
  var screens = {};
  root.querySelectorAll('[data-lgp-screen]').forEach(function (s) { screens[s.dataset.lgpScreen] = s; });
  var state = { buyingFor: null, email: null, screen: 'cards', picks: [] };
  var lastFocus = null;

  function track(event, props) {
    if (!window.lumiAnalytics) return;
    var p = { placement: PLACEMENT, store: 'lumi', landing_page: location.pathname };
    Object.keys(props || {}).forEach(function (k) { p[k] = props[k]; });
    try { window.lumiAnalytics.capture(event, p); } catch (e) {}
  }

  function show(name) {
    Object.keys(screens).forEach(function (k) {
      var on = k === name;
      screens[k].hidden = !on;
      screens[k].classList.toggle('is-on', on);
    });
    state.screen = name;
    dialog.scrollTop = 0;
  }

  function open() {
    try { sessionStorage.setItem(SHOWN, '1'); } catch (e) {}
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lgp-lock');
    document.addEventListener('keydown', onKey);
    setTimeout(function () { dialog.focus(); }, 50);
    track('popup_opened', {});
  }

  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lgp-lock');
    document.removeEventListener('keydown', onKey);
    if (!state.email) {
      var days = parseFloat(cfg.suppressDays);
      if (days > 0) { try { localStorage.setItem(SNOOZE, String(Date.now() + days * 864e5)); } catch (e) {} }
      track('popup_closed', { step_name: state.screen, buying_for: state.buyingFor });
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(dialog.querySelectorAll('button, a[href], input'), function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }

  root.querySelectorAll('[data-lgp-close]').forEach(function (b) { b.addEventListener('click', close); });
  var go = root.querySelector('[data-lgp-go]');
  if (go) go.addEventListener('click', function () { track('popup_cta_clicked', { buying_for: state.buyingFor }); close(); });

  /* Card game: whichever card they tap, the n-th flip reveals the n-th gift. */
  var CDN = 'https://cdn.shopify.com/s/files/1/0685/2585/0683/files/';
  // Coupon ticket for the $140 card (same art as snippets/lumi-coupon-svg.liquid).
  var COUPON = '<svg class="lumi-coupon" viewBox="0 0 120 76" role="img" aria-label="$140 off coupon"><path d="M8 2h104a6 6 0 0 1 6 6v22a8 8 0 0 0 0 16v22a6 6 0 0 1-6 6H8a6 6 0 0 1-6-6V46a8 8 0 0 0 0-16V8a6 6 0 0 1 6-6z" fill="#E6F7EA" stroke="#2E8B57" stroke-width="2.5"/><path d="M34 10v56" stroke="#2E8B57" stroke-width="2" stroke-dasharray="4 4" stroke-linecap="round"/><text x="19" y="38" transform="rotate(-90 19 38)" text-anchor="middle" dominant-baseline="central" font-family="&quot;Gothic 821 Condensed&quot;, &quot;Arial Narrow&quot;, Impact, sans-serif" font-size="12" letter-spacing="1.5" fill="#2E8B57">SAVE</text><text x="76" y="37" text-anchor="middle" font-family="&quot;Gothic 821 Condensed&quot;, &quot;Arial Narrow&quot;, Impact, sans-serif" font-size="25" fill="#1F6B42">$140</text><text x="76" y="51" text-anchor="middle" font-family="Nunito, system-ui, sans-serif" font-weight="900" font-size="7.5" letter-spacing=".6" fill="#2E8B57">OFF YOUR BOX</text></svg>';
  if (cfg.coupon) COUPON = COUPON.replace(/\$140/g, cfg.coupon);
  var GIFTS = cfg.gifts || [
    { name: 'Save ' + (cfg.coupon || '$140') + ' coupon!', mini: 'You save ' + (cfg.savePct || 58) + '%', save: true },
    { name: 'Gift box', mini: 'Extra protection', img: CDN + 'lumi-gift-giftbox-cut3.webp?width=240' },
    { name: 'Custom tools', mini: 'Easy for beginners', img: CDN + 'lumi-gift-tools-cut3.webp?width=240' },
    { name: 'Pressing board', mini: 'Make clay anywhere', img: CDN + 'lumi-gift-board-cut4.webp?width=240' }
  ];
  var N = GIFTS.length;
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-lgp-card]'));
  var won = root.querySelector('[data-lgp-won]');
  var feedback = root.querySelector('[data-lgp-feedback]');
  function confetti() {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var colors = ['#F46A79', '#FFF088', '#62B583', '#FF9E97', '#7DDAFF', '#F7B661'];
    for (var n = 0; n < 80; n++) {
      var c = document.createElement('i'); c.className = 'lgp-confetti';
      var sz = 6 + Math.random() * 7;
      c.style.cssText = 'left:' + Math.random() * 100 + 'vw;width:' + sz + 'px;height:' + sz * (Math.random() > .5 ? 1.6 : 1) + 'px;background:' + colors[n % colors.length] +
        ';animation-duration:' + (1.6 + Math.random() * 1.6) + 's;animation-delay:' + Math.random() * .4 + 's;--dx:' + (Math.random() * 120 - 60) + 'px;--r:' + (Math.random() * 900 - 450) + 'deg';
      c.addEventListener('animationend', function () { this.remove(); });
      root.appendChild(c);
    }
  }
  cards.forEach(function (card, i) {
    card.addEventListener('click', function () {
      if (state.picks.length >= N || state.picks.indexOf(i) >= 0) return;
      var g = GIFTS[state.picks.length];
      state.picks.push(i);
      var front = card.querySelector('.lgp-card-front');
      // Same three rows on every card: art box (picture centred), name (always two lines tall, bottom-aligned), mini.
      front.innerHTML = '<span class="lgp-card-art">' + (g.save ? COUPON : '<img src="' + g.img + '" alt="">') + '</span>' +
        '<span class="lgp-card-name">' + g.name + '</span><span class="lgp-card-mini">' + g.mini + '</span>';
      card.classList.add('is-revealed'); card.setAttribute('aria-pressed', 'true');
      card.setAttribute('aria-label', 'Card ' + (i + 1) + ': ' + g.name);
      won.textContent = state.picks.length + '/' + N;
      feedback.textContent = 'You won ' + g.name + '.';
      track('quiz_answer', { step: 0, step_name: 'card_flip', question: 'Flip a card', answer: g.name });
      if (state.picks.length === N) {
        cards.forEach(function (c) { if (!c.classList.contains('is-revealed')) { c.disabled = true; c.classList.add('is-locked'); } });
        confetti();
        setTimeout(function () { show('pick'); }, 1500);
      }
    });
  });

  root.querySelectorAll('[data-lgp-for]').forEach(function (b) {
    b.addEventListener('click', function () {
      root.querySelectorAll('[data-lgp-for]').forEach(function (x) { x.classList.toggle('sel', x === b); });
      state.buyingFor = b.dataset.lgpFor;
      track('quiz_answer', { step: 1, step_name: cfg.stepName || 'buying_for', question: cfg.question || 'Who are you buying for?', answer: state.buyingFor });
      setTimeout(function () {
        show('email');
        var input = root.querySelector('[data-lgp-email]');
        if (input) setTimeout(function () { input.focus(); }, 80);
      }, 260);
    });
  });

  /* The email form is Shopify's own customer form ({% form 'customer' %}), aimed at a hidden iframe. The browser's
     own type=email/required check blocks bad input before any submit event, so nothing invalid reaches Shopify.
     On a valid submit we tag it and let it go: Shopify's spam check (hCaptcha) takes over, then posts into the
     frame. The frame's load (its URL says accepted or challenged) moves us on to the thank-you screen. */
  /* Optional second copy into Lumi's Supabase (section settings). Same row shape as the old quiz used, so the
     existing customer_base table takes it as-is; retried, and reported to PostHog if it still fails. */
  function saveToSupabase(email, attempt) {
    attempt = attempt || 1;
    if (!cfg.supabaseUrl || !cfg.supabaseAnonKey) return;
    fetch(cfg.supabaseUrl.replace(/\/+$/, '') + '/rest/v1/' + (cfg.supabaseTable || 'customer_base'), {
      method: 'POST', keepalive: true,
      headers: { 'Content-Type': 'application/json', apikey: cfg.supabaseAnonKey, Authorization: 'Bearer ' + cfg.supabaseAnonKey, Prefer: 'return=minimal' },
      body: JSON.stringify({ email: email, landing_page: PLACEMENT + '/' + (state.buyingFor || 'unknown'), purchased: false })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      track('popup_supabase_saved', { email: email });
    }).catch(function (e) {
      if (attempt < 3) { setTimeout(function () { saveToSupabase(email, attempt + 1); }, attempt * 800); return; }
      track('popup_supabase_failed', { email: email, reason: (e && e.message) || 'unknown' });
    });
  }

  var form = root.querySelector('[data-lgp-form]');
  var input = root.querySelector('[data-lgp-email]');
  var tags = root.querySelector('[data-lgp-tags]');
  var submit = root.querySelector('[data-lgp-submit]');
  var sink = root.querySelector('[data-lgp-sink]');
  form.setAttribute('target', 'lgp-sink');
  var finished = false;
  function finish(ok, reason) {
    if (finished) return; finished = true;
    track(ok ? 'popup_signup_saved' : 'popup_signup_write_failed', { email: state.email, buying_for: state.buyingFor, reason: reason });
    submit.disabled = false;
    show('done');
  }
  sink.addEventListener('load', function () {
    if (!state.email) return; // the frame's initial about:blank
    var href = '';
    try { href = sink.contentWindow.location.href; } catch (e) { href = 'cross-origin'; }
    if (href === 'about:blank') return;
    finish(!/challenge/.test(href), href.replace(/^https?:\/\/[^/]+/, '').slice(0, 80));
  });
  form.addEventListener('submit', function () {
    var v = (input.value || '').trim();
    state.email = v;
    tags.value = ['newsletter', cfg.tag || 'popup-free-gifts', (cfg.answerPrefix || 'buying-for-') + (state.buyingFor || 'unknown')].join(',');
    submit.disabled = true;
    track('email_submitted', { email: v, buying_for: state.buyingFor });
    track('quiz_completed', { email: v, buying_for: state.buyingFor });
    if (window.lumiAnalytics) {
      try { window.lumiAnalytics.identify(v, { email_source: PLACEMENT, buying_for: state.buyingFor }); window.lumiAnalytics.stampCart(true); } catch (x) {}
    }
    try { localStorage.setItem(DONE, '1'); } catch (x) {}
    saveToSupabase(v);
    // If the spam check needs a puzzle the shopper can still solve it; don't strand them if it never returns.
    setTimeout(function () { finish(false, 'timeout'); }, 45000);
  });

  // Warm the gift pictures (flipped card faces, the "You won" tiles, the thank-you scene) while the popup waits to
  // open, so a flipped card never shows a blank white face while its picture downloads. Kept referenced until used.
  var warmed = GIFTS.filter(function (g) { return g.img; }).map(function (g) {
    var im = new Image(); im.decoding = 'async'; im.src = g.img;
    if (im.decode) im.decode().catch(function () {});
    return im;
  });
  root.querySelectorAll('img[loading="lazy"]').forEach(function (im) { im.loading = 'eager'; });

  var delay = parseFloat(cfg.delay);
  if (isNaN(delay)) delay = 2.5;
  setTimeout(open, forceOpen ? 300 : delay * 1000);
})();
